<template>
    <div class="modal fade" id="getAccessModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-xl modal-dialog-centered">
            <div class="modal-content modal-content--access">
                <button
                    type="button"
                    class="modal-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                >
                  <svg width="24" height="24">
                    <use href="/static/images/sprite/sprite.svg#cross-icon"></use>
                  </svg>
                </button>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-6">
                      <h2 class="modal-title">{{ title }}</h2>
                      <p class="modal-body__text" v-html="text"></p>
                      <div class="modal-body__controls">
                        <button
                            class="btn btn-default btn-default--converse"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                          Close
                        </button>
                        <a :href="$getSubdomainLink('payment', '/sign-up')" class="btn btn-primary">
                          <span>Join us</span>
                        </a>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <img
                        src="@/assets/images/modal/modal-body.png"
                        alt="Access Modal"
                        class="modal-body__img"
                      >
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalAccess",
    props: {
        title: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
    },
};
</script>

<style
  lang="scss"
  scoped
>
.btn-primary{
  position: relative;

  span {
    z-index: 1;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background-color: #0B0F0866;
    border-radius: 40px;
    opacity: 0;
    transition: $transition;
  }

  &:hover {
    color: $green-shade;
    background-color: $green;

    &::after {
      opacity: 1;
    }
  }
}
</style>